import { posts } from "assets/data/posts";
import { FeedPost } from "components";
import ReportPostsLayout from "layouts/ReportPostsLayout";

const OtherReports = () => {
    return (
        <ReportPostsLayout breadCrumbTitle="Other" title="Other Posts Reports">
            <>
                {posts.slice(0, 2).map((i) => (
                    <FeedPost post={i} key={i.id} />
                ))}
            </>
        </ReportPostsLayout>
    );
};

export default OtherReports;
